const trimTrailingSlash = (value = "") => String(value).trim().replace(/\/$/, "");

const withApiPath = (value = "") => {
  const base = trimTrailingSlash(value);
  if (!base) return "";
  return base.endsWith("/api") ? base : `${base}/api`;
};

const getRuntimeFallback = () => {
  const productionApiBase = "https://api.abroadjacks.com/api";
  if (typeof window === "undefined") return productionApiBase;

  const { hostname, origin } = window.location;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://localhost:5000/api";
  }

  if (hostname === "abroadjacks.com" || hostname === "www.abroadjacks.com") {
    return productionApiBase;
  }

  return withApiPath(origin);
};

export const BACKEND_URL = withApiPath(
  process.env.REACT_APP_BACKEND_URL ||
    process.env.REACT_APP_API_BASE_URL ||
    getRuntimeFallback()
);
